export const MALFUNCTION_REPAIR_SCAN_KEY = 'MALFUNCTION_REPAIR_SCAN_KEY'
export const MALFUNCTION_REPAIR_SELECTED_DEVICES_KEY = 'MALFUNCTION_REPAIR_SELECTED_DEVICES_KEY'
export const MALFUNCTION_REPAIR_ADDRESS_INFO_KEY = 'MALFUNCTION_REPAIR_ADDRESS_INFO_KEY'
export const MALFUNCTION_REPAIR_ORDER_FORM_DATA_KEY = 'MALFUNCTION_REPAIR_ORDER_FORM_DATA_KEY'
export const MALFUNCTION_REPAIR_FLY_LOGS_KEY = 'MALFUNCTION_REPAIR_FLY_LOGS_KEY'
export const MALFUNCTION_REPAIR_SELECTED_FLY_LOG_KEY = 'MALFUNCTION_REPAIR_SELECTED_FLY_LOG_KEY'
export const MALFUNCTION_REPAIR_ORDER_FORM_FIRST_DATA_KEY =
  'MALFUNCTION_REPAIR_ORDER_FORM_FIRST_DATA_KEY'
export const MALFUNCTION_REPAIR_ORDER_DETAIL_KEY = 'MALFUNCTION_REPAIR_ORDER_DETAIL_KEY'
export const IMAGE_GUID_URL_MAP_KEY = 'IMAGE_GUID_URL_MAP_KEY'
export const JIJIA_INSURANCE_REFUND_ORDER_DATA = 'JIJIA_INSURANCE_REFUND_ORDER_DATA'
export const NAMEPLATE_REISSUE_ADDRESS_INFO_KEY = 'NAMEPLATE_REISSUE_ADDRESS_INFO_KEY'
export const NAMEPLATE_REISSUE_MODIFY_ADDRESS_INFO_KEY = 'NAMEPLATE_REISSUE_MODIFY_ADDRESS_INFO_KEY'
export const TRAIN_NETWORK_ITEM_KEY = 'TRAIN_NETWORK_ITEM_KEY'
export const THIRD_PARTY_DRONE_PINGAN2024_OPERATOR_KEY = 'THIRD_PARTY_DRONE_PINGAN2024_OPERATOR_KEY'
export const DEVICETYPE = 'DEVICETYPE'
export const JIJIA_INSURANCE_CONFIRM_ORDER_DATA = 'JIJIA_INSURANCE_CONFIRM_ORDER_DATA'
export const INVOICE_USER_SELECT_KEY = 'INVOICE_USER_SELECT_KEY'
export const USER_AUTHORIZATION_STORAGE_KEY = 'USER_AUTHORIZATION_STORAGE_KEY'
export const USER_LOCATIONINFO_STORAGE_KEY = 'USER_LOCATIONINFO_STORAGE_KEY'
export const USER_ENTRY_URL_STORAGE_KEY = 'USER_ENTRY_URL_STORAGE_KEY'
export const AGRICULTURA_LOAN_UNACTIVETED_SNS_STORAGE_KEY =
  'AGRICULTURA_LOAN_UNACTIVETED_SNS_STORAGE_KEY'
export const AGRICULTURA_LOAN_SELECTED_ADDRESS_STORAGE_KEY =
  'AGRICULTURA_LOAN_SELECTED_ADDRESS_STORAGE_KEY'
export const CRM_AREA_INFO_STORAGE_KEY = 'CRM_AREA_INFO_STORAGE_KEY'
export const AGRICULTURA_LOAN_CONFIRM_USE_PACKAE_INFO_STORAGE_KEY =
  'AGRICULTURA_LOAN_CONFIRM_USE_PACKAE_INFO_STORAGE_KEY'
export const AGRICULTURA_LOAN_BIND_DEVICE_INFO_STORAGE_KEY =
  'AGRICULTURA_LOAN_BIND_DEVICE_INFO_STORAGE_KEY'
export const AGRICULTURA_LOAN_CURRENT_PACKAGE_SELECTION_INFO_STORAGE_KEY =
  'AGRICULTURA_LOAN_CURRENT_PACKAGE_SELECTION_INFO_STORAGE_KEY'
export const AGRICULTURA_LOAN_VERIFY_SMSCODE_STORAGE_KEY =
  'AGRICULTURA_LOAN_VERIFY_SMSCODE_STORAGE_KEY'
export const AGRICULTURA_LOAN_CURRENT_PACKAGE_SUBCODES_STORAGE_KEY =
  'AGRICULTURA_LOAN_CURRENT_PACKAGE_SUBCODES_STORAGE_KEY'
